import { List, ListProps } from "antd";
import { ReactElement } from "react";
import styled from "styled-components";

export const DisplayList = styled(List)`
  max-height: 280px;
  padding-right: 10px;
  overflow-y: auto;
` as <T>(props: ListProps<T>) => ReactElement;
